import React from 'react';
import { PageLayout } from '@/shared/layout';
import { Button, Card, Badge } from '@/components/ui';

export default function CompanyOnboardingPage() {
  const steps = [
    { id: 1, title: 'Tạo công ty', description: 'Đã hoàn thành đăng ký tổ chức ban đầu.', status: 'completed' },
    { id: 2, title: 'Cập nhật thông tin công ty', description: 'Bổ sung logo, website và thông tin liên hệ.', status: 'pending' },
    { id: 3, title: 'Mời thành viên', description: 'Thêm đội ngũ PM và Giám sát vào hệ thống.', status: 'pending' },
    { id: 4, title: 'Thiết lập vai trò', description: 'Cấu hình quyền hạn cho từng nhóm người dùng.', status: 'pending' },
    { id: 5, title: 'Tạo dự án đầu tiên', description: 'Bắt đầu khởi tạo không gian làm việc thực tế.', status: 'pending' },
  ];

  const breadcrumbs = [
    { label: 'Công ty', path: '/company' },
    { label: 'Hướng dẫn thiết lập' }
  ];

  return (
    <PageLayout
      title="Chào mừng bạn đến với Landscape!"
      description="Hoàn thành các bước dưới đây để bắt đầu vận hành hệ thống quản lý cảnh quan chuyên nghiệp."
      breadcrumbs={breadcrumbs}
    >
      <div className="max-w-3xl mx-auto space-y-8 py-4">
        <div className="text-center space-y-2">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-os-primary/10 text-os-primary text-3xl mb-2">
            <i className="ri-rocket-2-line" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900">Thiết lập tổ chức</h2>
          <p className="text-slate-500">Tiến trình hoàn thành: <span className="text-os-primary font-bold">20%</span></p>
          <div className="w-full bg-slate-100 h-2 rounded-full mt-4 overflow-hidden">
            <div className="bg-os-primary h-full transition-all duration-1000" style={{ width: '20%' }} />
          </div>
        </div>

        <div className="space-y-4">
          {steps.map((step) => (
            <Card 
              key={step.id} 
              className={`p-6 border-l-4 transition-all ${
                step.status === 'completed' ? 'border-l-emerald-500' : 'border-l-slate-200'
              }`}
            >
              <div className="flex items-start gap-4">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold ${
                  step.status === 'completed' ? 'bg-emerald-500 text-white' : 'bg-slate-100 text-slate-400'
                }`}>
                  {step.status === 'completed' ? <i className="ri-check-line" /> : step.id}
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-start">
                    <h4 className={`font-bold ${step.status === 'completed' ? 'text-slate-900' : 'text-slate-600'}`}>
                      {step.title}
                    </h4>
                    {step.status === 'completed' ? (
                      <Badge variant="success">Hoàn thành</Badge>
                    ) : (
                      <Button variant="primary" size="sm" outline>Bắt đầu ngay</Button>
                    )}
                  </div>
                  <p className="text-sm text-slate-500 mt-1">{step.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <div className="flex justify-center pt-6">
          <Button variant="ghost" icon="ri-question-line">Cần hỗ trợ thiết lập?</Button>
        </div>
      </div>
    </PageLayout>
  );
}
